var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoAgentic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384.6 116.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.9,63.6h19.7l22.8,41,22.6-41h19.5v52.9h-12.8l.5-43.7h-.2l-24,43.7h-11.7l-23.9-43.7h-.2l.5,43.7h-12.8v-52.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.3,63.6h16.2l29,52.9h-15.2l-6.8-13.1h-30.6l-6.7,13.1h-14.8l29-52.9h0ZM175.4,95.1l-11.1-22.3-11.3,22.3h22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,89.3l-26.5-25.6h17l17.9,18.4,18.2-18.4h16.5l-26.6,25.6,26.6,27.3h-17.3l-17.7-19.5-17.8,19.5h-16.8l26.5-27.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.6,89.3l-26.5-25.6h17l17.9,18.4,18.2-18.4h16.5l-26.6,25.6,26.6,27.3h-17.3l-17.7-19.5-17.8,19.5h-16.8l26.5-27.3h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.8,3.5h7.9l10.9,26.7L31.3,3.5h7.6l-14.7,33.4h-7.4L1.8,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7,11.2c11.1,0,15.3,6.5,15.3,13.3s-4.3,13.3-15.3,13.3-15.3-6.5-15.3-13.3,4.3-13.3,15.3-13.3ZM51.7,32.9c6.3,0,8.6-4.1,8.6-8.4s-2.3-8.4-8.6-8.4-8.6,4.1-8.6,8.4,2.3,8.4,8.6,8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2,3.3h0c1.8,0,3.2,1.4,3.2,3.2h0c0,1.8-1.4,3.2-3.2,3.2h0c-1.8,0-3.2-1.4-3.2-3.2h0c0-1.8,1.4-3.2,3.2-3.2ZM71,12.1h6.5v24.8h-6.5V12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6,20.8c-.5-2.6-3.2-4.7-6.9-4.7-6,0-8.6,4.1-8.6,8.4s2.3,8.4,7.9,8.4,6.4-2,7.7-5.5h6.7c-1.5,10.3-12,10.4-13.7,10.4-11.1,0-15.3-6.5-15.3-13.3s5.8-13.3,15.3-13.3,12.2,1.3,13.6,9.6h-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.8,26.1c0,2.8,2,7,8.4,7s6.1-1.5,7.4-3.6h7c-1.4,2.8-4.8,8.2-14.2,8.2s-15.3-6.5-15.3-13.1,6.1-13.6,14.9-13.6,15.2,6.8,15.2,14v.9h-23.4s0,.2,0,.2ZM136.5,22c-.8-5-5.2-6.5-8.4-6.5s-7.2,1.4-8.3,6.5h16.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.9,3.5h8.3l14.9,33.4h-7.8l-3.5-8.3h-15.7l-3.5,8.3h-7.6l14.9-33.4h0ZM185.7,23.4l-5.7-14.1-5.8,14.1h11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.7,3.5h7v33.4h-7V3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,3.5h8.3l14.9,33.4h-7.8l-3.5-8.3h-15.7l-3.5,8.3h-7.6l14.9-33.4h0ZM252.8,23.4l-5.7-14.1-5.8,14.1h11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.4,12v24c0,5.9-3.8,11.1-14.7,11.1s-14-1.7-14.5-8.1h6.7c.7,3.2,3.7,3.7,7.6,3.7,7.4,0,8.5-3.9,8.5-7.2v-3h-.1c-3.1,2.9-6.3,4-10.1,4-6.5,0-13.8-3.3-13.8-12.5s4.2-12.6,13.7-12.6,8.7,1.6,10.2,4.2h0v-3.6h6.5,0ZM281.6,31.7c4.9,0,8.3-3.2,8.3-7.8s-5.6-7.5-8.9-7.5c-4.8,0-8.4,3.1-8.4,7.6s2.2,7.7,9,7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.2,26.1c.1,2.8,2,7,8.4,7s6.1-1.5,7.4-3.6h7c-1.4,2.8-4.8,8.2-14.2,8.2s-15.3-6.5-15.3-13.1,6.1-13.6,14.9-13.6,15.2,6.8,15.2,14v.9h-23.4v.2ZM323.8,22c-.8-5-5.2-6.5-8.4-6.5s-7.2,1.4-8.3,6.5h16.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.5,12.1h6.5v3.7h0c2.1-2.7,5.4-4.4,9.8-4.4s10.5,1.9,10.5,8.6v16.8h-6.5v-14.8c0-2.7-.9-5.7-6.2-5.7s-7.7,1.9-7.7,7.2v13.3h-6.5V12h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.5,16.8h-5.1v-4.7h5.1v-7.7h6.5v7.7h6.7v4.7h-6.7v11.3c0,2.9.1,4.4,2.3,4.4h4.6v4.7c-1.7.2-3,.4-5,.4-7.9,0-8.5-2.8-8.5-7.5v-13.2h.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoAgentic);
export default __webpack_public_path__ + "static/media/go-agentic.e2ff1e236c293250fce8ea81a4991ac3.svg";
export { ForwardRef as ReactComponent };